import { styled } from '@mui/material/styles';

export const StyledPageNotFound = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  width: 80%;
  margin: auto;
  padding: 50px 0;

  .title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
  }

  img {
    width: 100%;
  }
`;
